import { Directive, ElementRef, Input, HostListener } from '@angular/core';
import { LoggingService } from '@app/core/services/logging/logging.service';
import {
  ConfettiService,
  ConfettiOptions,
} from '@app/core/services/confetti/confetti.service';

@Directive({
  selector: '[appConfetti]',
  standalone: true,
})
export class ConfettiDirective {
  @Input() confettiOptions: Partial<ConfettiOptions> = {};
  @Input() confettiType: 'default' | 'success' | 'celebration' = 'default';
  @Input() confettiFromElement = true;

  constructor(
    private elementRef: ElementRef,
    private confettiService: ConfettiService,
  ) {}

  @HostListener('click')
  async onClick(): Promise<void> {
    try {
      switch (this.confettiType) {
        case 'success': {
          if (this.confettiFromElement) {
            await this.confettiService.showConfettiFromElement(
              this.elementRef.nativeElement,
              this.confettiOptions,
            );
          } else {
            await this.confettiService.showSuccessConfetti(
              this.confettiOptions,
            );
          }
          break;
        }
        case 'celebration': {
          if (this.confettiFromElement) {
            await this.confettiService.showConfettiFromElement(
              this.elementRef.nativeElement,
              this.confettiOptions,
            );
          } else {
            await this.confettiService.showCelebrationConfetti(
              this.confettiOptions,
            );
          }
          break;
        }
        default: {
          if (this.confettiFromElement) {
            await this.confettiService.showConfettiFromElement(
              this.elementRef.nativeElement,
              this.confettiOptions,
            );
          } else {
            await this.confettiService.showConfetti(this.confettiOptions);
          }
          break;
        }
      }
    } catch (error) {
      LoggingService.error('Error showing confetti:', error);
    }
  }
}
